import { Store, configureStore } from "@reduxjs/toolkit";
import { Immutable } from "immer";
import React, { useMemo } from "react";
import { Provider } from "react-redux";

import { reverse } from "@reactivated";

import {
    IProductID,
    WebPageURL,
    isoWebPageURL,
} from "../../../models/nominals";
import { middleware } from "../../../store/middleware";
import { coreReducers } from "../../../store/reducers";
import { IRootState } from "../../../store/reducers.interfaces";
import { usePageURL } from "../../../utils/urls";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { Configurator } from "../../configurator/Configurator";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { getDefaultConfiguratorOptionSet } from "../../configurator/utils";

type IMicroConfiguratorProps = Immutable<{
    rootProductIDs: ReadonlyArray<IProductID>;
    basketLink?: WebPageURL;
    financingLink?: WebPageURL;
}>;

// NOTE: This is a temporary solution to the MicroConfigurator functionality,
//       written by @cweber and @zlebar

export const MicroConfiguratorRowContent = (
    props: IMicroConfiguratorProps,
): React.ReactNode => {
    const financeLink = usePageURL("finance_link");
    const homeLink = usePageURL("home");

    // Required: Redux store must be stable to prevent state resets and infinite loops
    const microStore = useMemo<Store<IRootState>>(() => {
        return configureStore({
            reducer: coreReducers,
            middleware: (getDefaultMiddleware) => {
                return getDefaultMiddleware().concat(middleware);
            },
            devTools: {
                name: `MicroConfigurator-${props.rootProductIDs}`,
            },
        });
    }, [props.rootProductIDs]);

    return (
        <Provider store={microStore}>
            <Configurator
                optionSet={{
                    ...getDefaultConfiguratorOptionSet(),
                    product_ids: props.rootProductIDs,
                }}
                enableHistoryInteraction={false}
                financingLink={props.financingLink || financeLink || homeLink}
                basketLink={
                    props.basketLink ||
                    isoWebPageURL.wrap(reverse("basket:summary"))
                }
                configureGiftsLink={isoWebPageURL.wrap(
                    reverse("basket:configure-gifts"),
                )}
                configType={"micro"}
                buttonColor={"primary-congress-blue"}
                showShippingLead={false}
                showFeelScale={true}
                showPreTitle={false}
                showVariantCallout={false}
                strikeThroughMSRP={false}
                actualPriceStyle={""}
                boxHeaderContent={""}
                topBadgeContent={""}
                showFinancingModal={true}
            />
        </Provider>
    );
};
